import type { Dayjs } from 'dayjs';

export type DayName =
  | 'sunday'
  | 'monday'
  | 'tuesday'
  | 'wednesday'
  | 'thursday'
  | 'friday'
  | 'saturday';

const weekdaysMap: Record<DayName, number> = {
  sunday: 0,
  monday: 1,
  tuesday: 2,
  wednesday: 3,
  thursday: 4,
  friday: 5,
  saturday: 6,
};

export function nextNamedDay(this: Dayjs, dayName: DayName): Dayjs {
  const targetDay = weekdaysMap[dayName];
  const currentDay = this.day();
  const daysToAdd = (targetDay + 7 - currentDay) % 7 || 7;
  return this.add(daysToAdd, 'day').startOf('day');
}

export function previousNamedDay(this: Dayjs, dayName: DayName): Dayjs {
  const targetDay = weekdaysMap[dayName];
  const currentDay = this.day();
  const daysToSubtract = (currentDay - targetDay + 7) % 7 || 7;
  return this.subtract(daysToSubtract, 'day').startOf('day');
}
